import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      (error.response?.status === 401
        ? "Invalid email or password"
        : "An error occurred during login. Please try again.");
    throw new Error(message);
  }
};

export const logout = async () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const token = user?.token;

    if (token) {
      await axios.post(
        `${API_URL}/auth/logout`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    }
  } catch (error) {
    // still clear local session even if API fails
    console.error("Logout API failed:", error);
  } finally {
    localStorage.removeItem("user");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("token");
  }
};

export const getToken = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user?.token || localStorage.getItem("token") || null;
  } catch {
    return null;
  }
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  return !!getToken();
};